export default __webpack_public_path__ + "static/media/octahedron.c3a7f4bc.svg";